import { useSignFormEntryMutation } from "../../../services/api/formsApi";
import { useCallback } from "react";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import { useActionSignatureContext } from "app/features/actionSignature/providers/ActionSignatureProvider";
import { FormTagTitles } from "../../../services/api/types/forms/enums/FormEnums";

interface Props {
  form: SubmittedFormModel;
}

export function useHandleFormSignOff({ form }: Props) {
  const { showNewToast, showErrorToast } = useDisplayToast();
  const { showActionSignatureModal } = useActionSignatureContext();

  const [triggerSignOff, { isLoading: isSignOffLoading }] =
    useSignFormEntryMutation();

  const formTitle = FormTagTitles[form.form.tag] ?? form.form.name ?? "Form";

  const handleSignOff = useCallback(async () => {
    const result = await showActionSignatureModal({
      title: `Sign off ${formTitle.toLowerCase()}`,
      description: `Please enter your password to sign off the ${formTitle.toLowerCase()}`,
    });
    if (!result) return;

    try {
      await triggerSignOff({ entryId: form.id }).unwrap();
      showNewToast({
        title: `${formTitle} signed off`,
        message: `The ${formTitle.toLowerCase()} has been signed off successfully.`,
        type: "success",
      });
    } catch (error) {
      showErrorToast(error);
    }
  }, [form.id, formTitle, triggerSignOff, showErrorToast, showNewToast]);
  return {
    handleSignOff,
    isSignOffLoading,
  };
}
